/**
 * Perfil salvo na conta (Perfil e preferências › Seu negócio) no formato do onboarding, para o
 * guia aberto pelo menu ou pelo Início sugerir as mesmas buscas de "Sua primeira busca".
 */
import type { AccountProfile } from '../../api/account';
import {
  customerByLegacy,
  findSegment,
  isReach,
  sectorByIndustry,
  type Segment,
} from '../onboarding/catalog';
import type { OnboardingResult } from '../onboarding/OnboardingDialog';

export function perfilDaConta(
  perfil: Pick<AccountProfile, 'industry' | 'customer' | 'segment' | 'reach'> | null | undefined,
  nomeDoSegmento: (segment: Segment) => string,
): OnboardingResult | null {
  if (!perfil) return null;
  const customer = customerByLegacy(perfil.customer ?? undefined);
  const reach = perfil.reach ?? undefined;
  if (!customer || !isReach(reach)) return null;
  const achado = findSegment(perfil.segment ?? undefined);
  const setor = achado?.sector ?? sectorByIndustry(perfil.industry ?? undefined) ?? null;
  if (!setor && !perfil.segment) return null;
  return {
    sectorId: setor?.id ?? null,
    segmentId: achado?.segment.id ?? null,
    segmentLabel: achado ? nomeDoSegmento(achado.segment) : (perfil.segment ?? ''),
    customer,
    reach,
  };
}
